<template>
  <div>
    <button class="dropdown-btn" @click="togglePopup" :class="{ 'active-btn': btnState }">
      {{ btnText }}
      <div
        class="reset-btn"
        v-show="optionSelected"
        @click="resetBtnClick"
        :class="{ 'active-reset-btn': optionSelected }"
      ></div>
      <div class="arrow-wrap">
        <div class="arrow-down"></div>
      </div>
    </button>
    <div v-show="active" ref="main" class="dropdown-modal-wrap">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: false,
    };
  },
  props: {
    btnText: {
      type: String,
      default: '',
    },
    optionSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    btnState() {
      return this.active || this.optionSelected;
    },
  },
  methods: {
    togglePopup(e) {
      if (e.target.classList.contains('reset-btn')) this.active = false;
      else this.active = !this.active;
    },
    checkOutFocus(evt) {
      if (!this.$refs.main || !this.$refs.main.contains(evt.target)) {
        this.active = false;
      }
    },
    resetBtnClick() {
      this.$emit('reset');
    },
  },
  watch: {
    active(isActive) {
      if (isActive) {
        setTimeout(() => {
          document.addEventListener('click', this.checkOutFocus);
        }, 100);
      } else {
        document.removeEventListener('click', this.checkOutFocus);
      }
    },
  },
};
</script>
<style scoped>
.dropdown-btn {
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  padding: 7px 7px 7px 15px;
  color: #9a9a9a;
}

.arrow-down {
  width: 0;
  height: 0;
  border-right: 3px solid transparent;
  border-top: 5px solid #9a9a9a;
  border-left: 3px solid transparent;
}

.arrow-wrap {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
}

.active-btn {
  color: #252525;
}

.active-btn .arrow-down {
  border-top: 5px solid #252525;
}

.reset-btn {
  background-image: url('data:image/svg+xml;utf-8,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.14922 12.55L3.44922 11.85L7.29922 7.99995L3.44922 4.14995L4.14922 3.44995L7.99922 7.29995L11.8492 3.44995L12.5492 4.14995L8.69922 7.99995L12.5492 11.85L11.8492 12.55L7.99922 8.69995L4.14922 12.55Z" fill="%23252525"/></svg>');
  background-repeat: no-repeat;
  width: 16px;
  height: 16px;
  margin-left: 6px;
}

.active-reset-btn + .arrow-wrap {
  margin: 0;
}

.dropdown-modal-wrap {
  position: absolute;
  z-index: 4;
  margin-top: 8px;
  left: 0;
  filter: drop-shadow(0px 1px 8px rgba(0, 0, 0, 0.25));
  background: #f7f7f9;
}

/* laptop */
@media (min-width: 992px) and (max-width: 1199px) {
  .dropdown-modal-wrap {
    width: 100%;
    left: 0;
    margin-top: 9px;
    height: 232px;
  }
}

/* desktop */
@media (min-width: 1200px) {
  .dropdown-modal-wrap {
    width: 831px;
  }
}
</style>
